var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_icon",
    fill: "#837d8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0 C16.2989899,0 21,4.70900105 21,10.5178482 C21,16.0327934 16.7626564,20.5563716 11.3713111,21 L11.371824,13.9716319 L13.5243153,13.9685813 L13.8183881,11.0145142 L11.3687923,11.0145142 L11.371824,9.22108193 C11.371824,8.50115588 11.4385209,8.01213551 12.4692914,8.01213551 L12.4692914,8.01213551 L14.0275738,8.01213551 L14.0275738,5.00172002 L11.3475705,5.00172002 C8.70394737,5.00172002 8.0299667,6.76235145 8.0299667,9.01974668 L8.0299667,9.01974668 L8.0299667,11.0175647 L6.63236317,11.0175647 L6.63236317,13.9716319 L8.0299667,13.9716319 L8.02943496,20.7428978 C3.4225603,19.629989 0,15.4742889 0,10.5178482 C0,4.70900105 4.70101013,0 10.5,0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebookIcon);
export default __webpack_public_path__ + "static/media/footer_facebook_icon.0828322e.svg";
export { ForwardRef as ReactComponent };